import { Link } from "react-router-dom";
import MenyService from "../MenuService"
import MobileMenu from "../MobileMenu"

export default function Header1({ scroll, isMobileMenu, handleMobileMenu, isSidebar, handlePopup, handleSidebar }) {
    return (
        <>
            <header className={`main-header header-style-one ${scroll ? "fixed-header" : ""}`}>
                {/* Header Top */}
                <div className="header-top-1">
                    <div className="auto-container">
                        <div className="header-top-1-row d-flex align-items-center justify-content-evenly">
                            <div className="header-top-1-left-column">
                                <ul className="header-top-1-contact-info d-flex align-items-center"  
                                 style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        height: '100%',
                                        gap: '250px', 
                                    }}>
                                    <li><i className="icon-1"></i><span>Open Hours:</span> Mon-Fri 8:00 am-6:00 pm</li>
                                    <li><i className="icon-2"></i><span>Phone:</span> <Link href="tel: 0422 411 652">0422 411 652</Link></li>
                                    <li><i className="icon-3"></i><span>Email:</span> <Link href="mailto:admin@newranss.com.au">admin@newranss.com.au</Link></li>
                                </ul>
                            </div>
                            <div className="header-top-1-right-column d-flex align-items-center">
                                {/* <div className="header-top-1-login"><Link href="/">Login</Link></div> */}
                                <ul className="header-top-1-social-icon d-flex align-items-center">
                                    {/* <li><Link href="/"><i className="fab fa-facebook-f"></i></Link></li> */}
                                    {/* <li><Link href="/"><i className="fab fa-twitter"></i></Link></li>
                                    <li><Link href="/"><i className="fab fa-linkedin-in"></i></Link></li> */}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Header Upper */}
                <div className="header-upper">
                    <div className="auto-container">
                        <div className="inner-container d-flex align-items-center justify-content-between">
                            <div className="logo-box">
                                <div className="logo"><a href="https://newranss.com.au/#banner"><img src="assets/images/newLogo.png" alt="" /></a></div>
                            </div>
                            <div className="middle-column">
                                <div className="nav-outer">
                                    <div className="mobile-nav-toggler" onClick={handleMobileMenu}><img src="assets/images/icons/icon-bar.png" alt="" /></div>
                                    <nav className="main-menu navbar-expand-md navbar-light">
                                        <div className="collapse navbar-collapse show clearfix" id="navbarSupportedContent">
                                            <MenyService />
                                        </div>
                                    </nav>
                                </div>
                            </div>
                            <div className="right-column">                        
                                <a href="https://newranss.com.au/#contact" className="btn-1"  rel="noopener noreferrer">Submit an Inquiry</a>

                            </div>                        
                        </div>
                    </div>
                </div>

                {/*End Header Upper*/}
                {/* Sticky Header  */}
                <div className={`sticky-header ${scroll ? "animated slideInDown" : ""}`}>
                <div className="header-upper">
                    <div className="auto-container">
                        <div className="inner-container d-flex align-items-center justify-content-between">                    
                            <div className="logo-box">
                            <div className="logo"><a href="https://newranss.com.au/#banner"><img src="assets/images/newLogo.png" alt="" /></a></div>

                            </div>
                            <div className="middle-column">
                                <div className="nav-outer">
                                    <div className="mobile-nav-toggler"><img src="assets/images/icons/icon-bar-2.png" alt="" /></div>                        
                                    <nav className="main-menu navbar-expand-md navbar-light">
                                        <MenyService />
                                    </nav>
                                </div>
                            </div>
                            <div className="right-column">                            
                                <div className="header-link-btn"><Link href="https://newranss.com.au/#contact" className="btn-1"><span>Submit an Inquiry</span></Link></div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>{/* End Sticky Menu */}
                {/* Mobile Menu  */}

                <MobileMenu handleMobileMenu={handleMobileMenu} handleSidebar={handleSidebar} isSidebar={isSidebar} />
            </header>
        </>
    )
}
